import { render } from "./RoomAdd.vue?vue&type=template&id=d31f5b4e"
import script from "./RoomAdd.vue?vue&type=script&lang=js"
export * from "./RoomAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__